var map = {
	"./arrow-left-32.png": 300,
	"./arrow-right-32.png": 931,
	"./close-32.png": 577,
	"./community-32.png": 932,
	"./facebook-32.png": 933,
	"./globe-32.png": 934,
	"./google-32.png": 935,
	"./hamburger-32.png": 578,
	"./help-32.png": 579,
	"./home-32.png": 936,
	"./jump-32.png": 937,
	"./logout-32.png": 580,
	"./news-32.png": 938,
	"./plane-32.png": 939,
	"./profile-32.png": 581,
	"./settings-32.png": 582
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 930;